import Api from '../Api';

import { url } from './config';
import { Region } from './types';

const api = new Api<Region>(url);

export default api;
